export var DietFoodDatabaseGroup;

(function (DietFoodDatabaseGroup) {
  DietFoodDatabaseGroup["brands"] = "brands";
  DietFoodDatabaseGroup["catalogues"] = "catalogues";
})(DietFoodDatabaseGroup || (DietFoodDatabaseGroup = {}));

export var DietFoodDatabaseType;

(function (DietFoodDatabaseType) {
  DietFoodDatabaseType["brand"] = "brand";
  DietFoodDatabaseType["category"] = "category";
})(DietFoodDatabaseType || (DietFoodDatabaseType = {}));

export var MoveAssetItemType;

(function (MoveAssetItemType) {
  MoveAssetItemType["aerobic"] = "aerobic";
  MoveAssetItemType["workout"] = "workout";
  MoveAssetItemType["session"] = "session";
})(MoveAssetItemType || (MoveAssetItemType = {}));

export var NoteAssetItemType;

(function (NoteAssetItemType) {
  NoteAssetItemType["sixGroup"] = "sixGroup";
  NoteAssetItemType["foodStuff"] = "foodStuff";
  NoteAssetItemType["calorieOr3Nutrition"] = "calorieOr3Nutrition";
})(NoteAssetItemType || (NoteAssetItemType = {}));

export var NoteRecordType;

(function (NoteRecordType) {
  NoteRecordType["NoteAsset"] = "Note::Asset";
  NoteRecordType["Note"] = "Note";
})(NoteRecordType || (NoteRecordType = {}));

export var FoodNoteItemType;

(function (FoodNoteItemType) {
  FoodNoteItemType["foodStuff"] = "FoodStuff";
  FoodNoteItemType["quickAdd"] = "QuickAdd";
})(FoodNoteItemType || (FoodNoteItemType = {}));

export var FoodNoteItemQuickAddType;

(function (FoodNoteItemQuickAddType) {
  FoodNoteItemQuickAddType["namedSixGroup"] = "named_six_group";
  FoodNoteItemQuickAddType["sixGroup"] = "six_group";
  FoodNoteItemQuickAddType["calorie"] = "calorie";
  FoodNoteItemQuickAddType["macros"] = "macros";
})(FoodNoteItemQuickAddType || (FoodNoteItemQuickAddType = {}));

export var FoodNoteItemCalorieQuickAddKind;

(function (FoodNoteItemCalorieQuickAddKind) {
  FoodNoteItemCalorieQuickAddKind["custom"] = "custom";
  FoodNoteItemCalorieQuickAddKind["alcohol"] = "alcohol";
  FoodNoteItemCalorieQuickAddKind["protein"] = "protein";
  FoodNoteItemCalorieQuickAddKind["fat"] = "fat";
  FoodNoteItemCalorieQuickAddKind["sugar"] = "sugar";
})(FoodNoteItemCalorieQuickAddKind || (FoodNoteItemCalorieQuickAddKind = {}));

export var FoodNoteItem3NutritionQuickAddKind;

(function (FoodNoteItem3NutritionQuickAddKind) {
  FoodNoteItem3NutritionQuickAddKind["sugar"] = "sugar";
  FoodNoteItem3NutritionQuickAddKind["refined_sugar"] = "refined_sugar";
  FoodNoteItem3NutritionQuickAddKind["protein"] = "protein";
  FoodNoteItem3NutritionQuickAddKind["fat"] = "fat";
})(FoodNoteItem3NutritionQuickAddKind || (FoodNoteItem3NutritionQuickAddKind = {}));

export var FoodLightType;

(function (FoodLightType) {
  FoodLightType["green"] = "green";
  FoodLightType["yellow"] = "yellow";
  FoodLightType["red"] = "red";
})(FoodLightType || (FoodLightType = {}));

export var NoteType;

(function (NoteType) {
  NoteType["FoodNote"] = "FoodNote";
  NoteType["WaterNote"] = "WaterNote";
  NoteType["MoveNote"] = "MoveNote";
  NoteType["LifeNote"] = "LifeNote";
  NoteType["DiagNote"] = "DiagNote";
  NoteType["StoolNote"] = "StoolNote";
  NoteType["SleepNote"] = "SleepNote";
  NoteType["MeditateNote"] = "MeditateNote";
  NoteType["FloweryNote"] = "FloweryNote";
  NoteType["DietNote"] = "DietNote";
  NoteType["MoodNote"] = "MoodNote";
})(NoteType || (NoteType = {}));

export var NoteFilterKey;

(function (NoteFilterKey) {
  NoteFilterKey["food"] = "food";
  NoteFilterKey["exercise"] = "exercise";
  NoteFilterKey["body"] = "body";
  NoteFilterKey["water"] = "water";
  NoteFilterKey["life"] = "life";
  NoteFilterKey["stool"] = "stool";
})(NoteFilterKey || (NoteFilterKey = {}));

export var MEAL_ORDER;

(function (MEAL_ORDER) {
  MEAL_ORDER[MEAL_ORDER["BREAKFAST"] = 1] = "BREAKFAST";
  MEAL_ORDER[MEAL_ORDER["MORNING_SNACK"] = 2] = "MORNING_SNACK";
  MEAL_ORDER[MEAL_ORDER["LUNCH"] = 3] = "LUNCH";
  MEAL_ORDER[MEAL_ORDER["AFTERNOON_SNACK"] = 4] = "AFTERNOON_SNACK";
  MEAL_ORDER[MEAL_ORDER["DINNER"] = 5] = "DINNER";
  MEAL_ORDER[MEAL_ORDER["EVENING_SNACK"] = 6] = "EVENING_SNACK";
  MEAL_ORDER[MEAL_ORDER["SNACK"] = 7] = "SNACK";
})(MEAL_ORDER || (MEAL_ORDER = {}));

export var TargetType;

(function (TargetType) {
  TargetType[TargetType["LOSE_WEIGHT"] = 1] = "LOSE_WEIGHT";
  TargetType[TargetType["GAIN_WEIGHT"] = 2] = "GAIN_WEIGHT";
  TargetType[TargetType["MAINTAIN_WEIGHT"] = 3] = "MAINTAIN_WEIGHT";
})(TargetType || (TargetType = {}));

export var NUTRITION_KEY;

(function (NUTRITION_KEY) {
  NUTRITION_KEY["calorie"] = "calorie";
  NUTRITION_KEY["refined_sugar"] = "refined_sugar";
})(NUTRITION_KEY || (NUTRITION_KEY = {}));

export var THREE_NUTRITION;

(function (THREE_NUTRITION) {
  THREE_NUTRITION["carbohydrate"] = "carbohydrate";
  THREE_NUTRITION["protein"] = "protein";
  THREE_NUTRITION["fat"] = "fat";
})(THREE_NUTRITION || (THREE_NUTRITION = {}));

export var THREE_NUTRITION_PERCENTAGE_KEY;

(function (THREE_NUTRITION_PERCENTAGE_KEY) {
  THREE_NUTRITION_PERCENTAGE_KEY["carbohydrate"] = "carbohydrate_percentage";
  THREE_NUTRITION_PERCENTAGE_KEY["protein"] = "protein_percentage";
  THREE_NUTRITION_PERCENTAGE_KEY["fat"] = "fat_percentage";
})(THREE_NUTRITION_PERCENTAGE_KEY || (THREE_NUTRITION_PERCENTAGE_KEY = {}));

export var SIX_FOOD_CATEGORY;

(function (SIX_FOOD_CATEGORY) {
  SIX_FOOD_CATEGORY["meat"] = "meat";
  SIX_FOOD_CATEGORY["meat_beans_high_fat"] = "meat_beans_high_fat";
  SIX_FOOD_CATEGORY["meat_beans_low_fat"] = "meat_beans_low_fat";
  SIX_FOOD_CATEGORY["meat_beans_medium_fat"] = "meat_beans_medium_fat";
  SIX_FOOD_CATEGORY["meat_beans_super_high_fat"] = "meat_beans_super_high_fat";
  SIX_FOOD_CATEGORY["vegetables"] = "vegetables";
  SIX_FOOD_CATEGORY["grains"] = "grains";
  SIX_FOOD_CATEGORY["oil"] = "oil";
  SIX_FOOD_CATEGORY["milk"] = "milk";
  SIX_FOOD_CATEGORY["milk_low_fat"] = "milk_low_fat";
  SIX_FOOD_CATEGORY["milk_skim"] = "milk_skim";
  SIX_FOOD_CATEGORY["milk_whole_fat"] = "milk_whole_fat";
  SIX_FOOD_CATEGORY["fruits"] = "fruits";
})(SIX_FOOD_CATEGORY || (SIX_FOOD_CATEGORY = {}));

export var DatabaseTabType;

(function (DatabaseTabType) {
  DatabaseTabType["SixFoodCategory"] = "SixFoodCategory";
  DatabaseTabType["Favorites"] = "Favorites";
  DatabaseTabType["Brand"] = "Brand";
  DatabaseTabType["Government"] = "Government";
  DatabaseTabType["Add"] = "Add";
  DatabaseTabType["History"] = "History";
  DatabaseTabType["Database"] = "Database";
})(DatabaseTabType || (DatabaseTabType = {}));